import universal from 'react-universal-component';

export default universal(() => import('./WaiverWire'));



// WEBPACK FOOTER //
// ./src/app/views/WaiverWire/index.js